<template>
  <div class="m-product-options-bundle">
    <MProductOptionBundleRz
      v-for="option in product.bundle_options"
      :key="('bundleOption_' + option.option_id)"
      :option="option"
      @option-changed="optionChanged"
      :error-messages="errorMessages"
      :ref="('bundleOption_' + option.option_id)"
    />
  </div>
</template>

<script>
import { ProductBundleOptions } from '@vue-storefront/core/modules/catalog/components/ProductBundleOptions'
import MProductOptionBundleRz from 'theme/components/molecules/m-product-option-bundle-rz'
import { Logger } from '@vue-storefront/core/lib/logger'
import { scrollTo } from 'theme/helpers/custom';

export default {
  mixins: [ProductBundleOptions],
  components: {
    MProductOptionBundleRz
  },
  props: {
    suppressScroll: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    optionChanged ({ fieldName, option, qty, value }) {
      ProductBundleOptions.methods.optionChanged.call(this, { fieldName, option, qty, value })

      this.configureBundleParts()
      if (!this.suppressScroll) {
        scrollTo('.product__configurator')
      }
    },
    configureBundleParts () {
      if (this.running) {
        return
      }
      this.running = true;

      let bundleOption = this.getBundleOption(this.getMainOption())
      const selectedArea = bundleOption.quantity * bundleOption.value.product.baseprice_product_amount;

      for (let _option of this.getAdditionalOptions()) {
        let _bundleOption = this.getBundleOption(_option)
        if (!_bundleOption.value) {
          continue
        }
        if (!_bundleOption.value.product.baseprice_product_amount || _bundleOption.value.product.baseprice_product_amount <= 0) {
          Logger.error('baseprice_product_amount not defined for ' + _bundleOption.value.product.sku)
          continue
        }
        _bundleOption.quantity = Math.ceil(selectedArea / _bundleOption.value.product.baseprice_product_amount)
      }
      this.running = false
    },
    getSortedBundleOptions () {
      return this.product.bundle_options.sort((a, b) => a.position - b.position)
    },
    getMainOption () {
      return this.getSortedBundleOptions().find((o) => o)
    },
    getAdditionalOptions () {
      return this.getSortedBundleOptions().filter((o) => o.option_id !== this.getSortedBundleOptions().find((o) => o).option_id)
    },
    getBundleOption (option) {
      return this.$refs['bundleOption_' + option.option_id][0];
    }
  }
}
</script>
